import { Constantes } from "../constants/constantsGlobal";
import { iResponse } from "../models/interfaceResponse";
import setupInterceptor from "./setupInterceptor";

export const charbotSaveProject = async (
    saveFormData : FormData,
    user: any, 
    setUser: (user: any) => void
  ): Promise<iResponse> => { 
    try {
        const response = await setupInterceptor(Constantes.URI_ChatBotProjectDatacenter, user,setUser, {
          method: 'POST', 
          body: saveFormData // `formData` automáticamente ajusta el Content-Type a multipart/form-data
        });  
        
        if (response.status == 403) {
          const data = await response.json(); 
          return data; 
        } 
        
      if (!response.ok) {
        const msg = response.text();
        throw { status: response.status, message: msg || "Error guardando proyecto" };
        //throw new Error(`Error en la solicitud: ${response.statusText}`);
      } 
      const data: iResponse = await response.json();
      return data;
    } catch (error) {
      console.error('Error al enviar datos:', error);
      throw error;
    }
  };